import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { API } from '../App';
import './PatientsPage.css';

export default function PatientsPage() {
  const [patients, setPatients] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const { t } = useTranslation();
  const practitionerId = accounts[0]?.localAccountId || '';

  useEffect(() => {
    if (!practitionerId) return;
    fetch(`${API}/api/patients?practitioner_id=${practitionerId}`)
      .then(r => r.json())
      .then(d => setPatients(d.patients || []))
      .finally(() => setLoading(false));
  }, [practitionerId]);

  return (
    <div className="patients-page">
      <header className="pp-header">
        <div>
          <p className="pp-eyebrow">{t('patients.eyebrow')}</p>
          <h1 className="pp-title">{t('patients.title')}</h1>
        </div>
        <button className="btn-primary" onClick={() => navigate('/patient/new/admin')}>
          {t('patients.new')}
        </button>
      </header>

      {loading && <PatientsSkeleton />}

      {!loading && patients.length === 0 && (
        <div className="pp-empty">
          <div className="empty-icon">⬡</div>
          <p>{t('patients.empty')}</p>
          <button className="btn-primary" onClick={() => navigate('/patient/new/admin')}>
            {t('patients.create_first')}
          </button>
        </div>
      )}

      {!loading && patients.length > 0 && (
        <div className="patients-grid">
          {patients.map((p, i) => (
            <PatientCard
              key={p.id}
              patient={p}
              index={i}
              onClick={() => navigate(`/patient/${p.id}/history`)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function PatientCard({ patient, index, onClick }) {
  const { t } = useTranslation();
  const initials = `${patient.first_name[0]}${patient.last_name[0]}`.toUpperCase();
  const count = patient.consultation_count || 0;

  return (
    <button
      className="patient-card"
      style={{ animationDelay: `${index * 0.07}s` }}
      onClick={onClick}
    >
      {patient.is_demo && <span className="demo-badge">Démo</span>}
      <div className="pc-avatar"><span>{initials}</span></div>
      <div className="pc-info">
        <div className="pc-name">
          {patient.first_name} <strong>{patient.last_name.toUpperCase()}</strong>
        </div>
        <div className="pc-meta">
          <span>{t('patients.consultations_count', { count })}</span>
        </div>
      </div>
      <div className="pc-arrow">→</div>
    </button>
  );
}

function PatientsSkeleton() {
  return (
    <div className="patients-grid">
      {[0,1,2].map(i => (
        <div key={i} className="patient-card skeleton-card">
          <div className="sk sk-avatar" />
          <div className="sk-lines">
            <div className="sk sk-line" />
            <div className="sk sk-line short" />
          </div>
        </div>
      ))}
    </div>
  );
}